namespace AuthConstants {
  // User can belong to a maximum of 1 group (model managers).
  export const GROUPS_MAX_LENGTH = 256;
  export const CLIENT_ID_MAX_LENGTH = 256;
  export const KEY_ID_MAX_LENGTH = 256;
}

export default AuthConstants;
